var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createSlice } from '@reduxjs/toolkit';
import { loadingSlice } from './LoadingStore';
export var defaultBannerState = {};
var getBannersReducer = function (state, action) {
    var _a;
    if (!action.payload || !action.payload.name) {
        return state;
    }
    var _b = action.payload, name = _b.name, payload = _b.payload;
    return __assign(__assign({}, state), (_a = {}, _a[name] = Array.isArray(payload) ? payload : [], _a));
};
var resetReducer = function () {
    return __assign({}, defaultBannerState);
};
export var bannerSlice = createSlice({
    name: 'banners',
    initialState: defaultBannerState,
    reducers: {
        getBanners: getBannersReducer,
        reset: resetReducer,
    },
});
var getBanners = function (dispatch, name, apiClient) { return __awaiter(void 0, void 0, void 0, function () {
    var result, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(loadingSlice.actions.setLoading({ action: 'getBanners' }));
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, 4, 5]);
                return [4 /*yield*/, apiClient().getBanner({ name: name })];
            case 2:
                result = _a.sent();
                dispatch(bannerSlice.actions.getBanners(__assign({ name: name }, result)));
                return [3 /*break*/, 5];
            case 3:
                error_1 = _a.sent();
                console.error('Failed to fetch banners:', error_1);
                return [3 /*break*/, 5];
            case 4:
                dispatch(loadingSlice.actions.unsetLoading({ action: 'getBanners' }));
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); };
export var bannerActions = function (dispatch, apiClient) {
    return {
        getBanners: function (name) { return getBanners(dispatch, name, apiClient); },
        reset: function () { return dispatch(bannerSlice.actions.reset()); },
    };
};
export var bannerSliceActions = bannerSlice.actions, bannerReducer = bannerSlice.reducer;
